import { PROYECT, api_get } from "services/api";

export const getCustomers = async (setSnackBar, station, search) => {
  const getCustomersUrl = `${process.env.REACT_APP_URL}${PROYECT}/customers?stations=${station}&filter=${search}`
  return await api_get(getCustomersUrl).then(customers => {
    if (customers.length === 0) setSnackBar('No se encontraron clientes.')
    return customers.map(customer => ({
      id: customer.id,
      name: customer.name,
      code: customer.code,
      value: customer.id,
      label: `${customer.name} - ${customer.code}`,
      accounts: (customer.accounts ?? []).map(acc => ({
        id: acc.id,
        value: acc.id,
        label: acc.alias ?? acc.code ?? acc.id,
      }))
    }))
  }).catch(err => {
    setSnackBar(err)
    return []
  })
}

const mapTanks = tanks => tanks.map(tank => ({
  ...tank,
  label: `${tank.brandName} - ${tank.serie}`,
  value: tank.id
}));

export const getTanks = async (setSnackBar, station) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/commodatos-tanks/available-by-station/${station}`
  return await api_get(url).then(tanks => {
    if (tanks.length === 0) setSnackBar('No se encontraron tanques')
    return mapTanks(tanks)
  }).catch(err => {
    setSnackBar(err)
    return []
  })
}

export const getAllTanksByStation = async (setSnackBar, station) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/commodatos-tanks/by-station/${station}`
  return await api_get(url).then(tanks => {
    if (tanks.length === 0) setSnackBar('No se encontraron tanques')
    return mapTanks(tanks)
  }).catch(err => {
    setSnackBar(err)
    return []
  })
}

